<div class="root">
  <div class="container" [class.-pressed]="isLikePressed" (click)="likeClick()">
    <ds-icon-thumb-up class="icon"></ds-icon-thumb-up>
    @if (likeCount && likeCount > 0) {
    <div class="count">{{ likeCount }}</div>
    }
  </div>
  @if (isDislikeEnabled) {
  <div class="container -dislike" [class.-pressed]="isDislikePressed" (click)="dislikeClick()">
    <ds-icon-thumb-down class="icon"></ds-icon-thumb-down>
  </div>
  }
</div>
